// extracted by mini-css-extract-plugin
export default {"address":"editPrint_address__34rac","formFields":"editPrint_formFields__yBAwO","corner_button":"editPrint_corner_button__MEyud","display_text":"editPrint_display_text__mAbR2"};